<div class="labels" *ngIf="interactive && (showLabels$ | async)">
  
  <ng-container *ngFor="let label of labels$ | async; trackBy: trackLabel">
    <app-label
      *ngIf="label.shown"
      [pinDraggable]="(draggable$ | async)?.pin"
      [tagDraggable]="(draggable$ | async)?.tag"      
      [label]="label"
      [collapsed]="labelsCollapsed$ | async"
      [collapsedMode]="labelsCollapsedMode$ | async">
    </app-label>
  </ng-container>

  <!-- context label -->
  <app-context-label
    *ngIf="(enableContextLabel$ | async) && (contextLabel$ | async)"
    [label]="contextLabel$ | async"
    [enableInfo]="(enableContextLabelInfo$ | async) && (layout$ | async)?.nodeInfo.enable"
    [enableActions]="enableContextLabelActions$ | async">
  </app-context-label>

</div>
